import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const fmt = (cents: number) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(cents / 100);

const formatStatus = (s: string) =>
  s.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

const InvoiceHistoryBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Invoice History";

  if (state.invoices.length === 0) {
    return (
      <div className="py-4">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
        <p className="text-sm text-slate-400 text-center py-4">No invoices in scope</p>
      </div>
    );
  }

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b-2" style={{ borderColor: "var(--color-primary)" }}>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Invoice #</th>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Matter</th>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Date</th>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Status</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Total</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Paid</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Balance</th>
          </tr>
        </thead>
        <tbody>
          {state.invoices.map((inv: any, i: number) => (
            <tr key={inv._id || i} className="border-b border-slate-100">
              <td className="py-2 font-mono text-slate-800">{inv.invoiceNumber}</td>
              <td className="py-2 text-slate-600">{inv.matterId?.title || "-"}</td>
              <td className="py-2 text-slate-600">
                {inv.issuedAt
                  ? new Date(inv.issuedAt).toLocaleDateString("en-CA")
                  : inv.createdAt
                  ? new Date(inv.createdAt).toLocaleDateString("en-CA")
                  : "-"}
              </td>
              <td className="py-2 text-slate-600">{formatStatus(inv.status)}</td>
              <td className="py-2 text-right text-slate-800">{fmt(inv.totalCents)}</td>
              <td className="py-2 text-right text-emerald-700">{fmt(inv.paidCents)}</td>
              <td className="py-2 text-right font-medium text-slate-800">{fmt(inv.balanceDueCents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceHistoryBlock;
